import React from "react"
import { graphql } from "gatsby"
import ReactMarkdown from "react-markdown"
import LayoutGeneric from "../components/LayoutGeneric"
import Seo from "../components/Seo";
import BookForm from "../components/BookForm"

export default function BookADemo({data}) {

  // console.log(data);
  const { image, title, subtitle, content, SEO} = data.page;

  return (
    <LayoutGeneric title={title} subtitle={subtitle} image={image.childImageSharp.gatsbyImageData} noBook={true}>
        <Seo 
        title={(SEO && SEO.title) ? SEO.title : title}
        description={(SEO && SEO.description) ? SEO.description : undefined }
        />
        <ReactMarkdown source={content} linkTarget="_blank"/>
        <div id="form">
          <BookForm pageName={title}></BookForm>
        </div>
    </LayoutGeneric>
  );
}

export const query = graphql`
  {
    page: strapiPages(slug: { eq: "book-a-demo" }) {
      content
      image {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      SEO {
        title
        description
      }
      slug
      subtitle
      title
      id
    }
  }
`
